import { Text, View, Image, Icon } from '@/components'
import { createStyles } from '@codeleap/styles'
import { ProfileApp } from '@packages/profiles/src'

type AppCardProps = {
  app: ProfileApp
  onSelect: (app: ProfileApp) => void
}

export const AppCard = ({ app, onSelect }: AppCardProps) => {
  const handleClick = () => {
    onSelect(app)
  }

  return (
    <View style={styles.appCard} onClick={handleClick}>
      <View style={styles.appCardHeader}>
        {app?.icon && (
          <View style={styles.appIcon}>
            <Image source={app.icon as any} alt={app.name} style={styles.appIconImage} />
          </View>
        )}

        <Icon name='link-external-02' style={styles.externalLinkIcon} />
      </View>

      {app?.name ? (<Text text={app.name} style={styles.appTitle} />) : null}

      {app?.description ? <Text text={app.description} style={styles.appDescription} /> : null}
    </View>
  )
}

const styles = createStyles(theme => ({
  appCard: {
    backgroundColor: theme.baseColors.neutralSolid0,
    borderRadius: theme.radius.regular,
    ...theme.presets.fullWidth,
    height: 183,
    ...theme.spacing.padding(2),
    ...theme.presets.column,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
    },
  },
  appCardHeader: {
    ...theme.presets.row,
    justifyContent: 'space-between',
    ...theme.presets.alignStart,
    marginBottom: theme.spacing.value(1),
  },
  appIcon: {
    width: 44,
    height: 44,
    borderRadius: theme.radius.small,
    ...theme.presets.center,
  },
  appIconImage: {
    width: 44,
    height: 44,
    borderRadius: theme.radius.small,
  },
  externalLinkIcon: {
    width: 16,
    height: 16,
    color: theme.colors.textCaption,
  },
  appTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colors.textHeadingRegular,
    marginBottom: theme.spacing.value(1),
  },
  appDescription: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.colors.textHeadingRegular,
    lineHeight: 1.5,
  },
  appContent: {
    ...theme.presets.column,
    ...theme.presets.flex,
    overflow: 'hidden',
    borderRadius: 16,
    ...theme.spacing.padding(4),
    backgroundColor: theme.baseColors.neutralSolid0,
  },
}))
